/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import moment from 'moment-timezone';

interface DatePickerArgs {
  selectedDate: moment.Moment;
  onSelect: (date: any) => unknown;
}

export default class DatePicker extends Component<DatePickerArgs> {
  get selectedDate() {
    // Convert the moment object passed in from outside to a moment object in
    // the local timezone - selectedDate is constructed using the selected
    // timezone, but FlyDatePicker needs an object in the local browser timezone
    let { selectedDate } = this.args;
    return moment()
      .year(selectedDate.year())
      .month(selectedDate.month())
      .date(selectedDate.date())
      .hour(selectedDate.hour())
      .minute(selectedDate.minute())
      .second(selectedDate.second());
  }

  @action
  onSelect(value: Record<string, any>) {
    this.args.onSelect(value.date);
  }
}
